import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    wlc: {
      brand: null,
      appCodename: null,
      logo: null,
      gbName: null,
      helpCenterUrl: null
    },
    user: {
      name: null,
      email: null,
      avatarUrl: null,
      adminPrivileges: false,
      owner: false,
      editor: false,
      viewer: false,
      root: false,
      appAdmin: false,
      system: false,
      impersonating: false,
      beginningOfWeek: null,
      timeZone: null,
      hasOpenaiKey: false,
      isOpenaiKeyValid: false,
      defaultLinda: false,
      ssoUser: false
    },
    organization: {
      obfuscatedId: null,
      name: null,
      sso: false,
      features: [],
      allowBulkPostingForLinda: false,
      keywordWalletBalance: null,
      geogridWalletBalance: null,
      isLinda: false,
      allowUsersForLinda: false,
      allowGgWidgetForLinda: false,
      allowWlcForLinda: false,
      subscriptionPastDue: false,
      daysPastDue: 0,
      proPlanSubscriber: false,
      vendasta: false
    },
    trueUserRoot: false,
    trueUserAppAdmin: false,
    trueUserContentTeam: false,
    trueUserSystem: false,
    sidebar: null,
    currentPath: null,
    googleMapApiKey: null,
    maptilerKey: null,
    orgAlerts: {
      base: {},
      custom: []
    }
  }),

  getters: {
    brand: (state) => state.wlc.brand || state.wlc.appCodename || 'App',
    isLv: (state) => state.wlc.appCodename === 'lv',
    isLbm: (state) => state.wlc.appCodename === 'lbm',
    hasFeature: (state) => (feature) => state.organization.features.includes(feature),
    canManageUsers: (state) => (!state.user.ssoUser || state.organization.allowUsersForLinda) && state.user.adminPrivileges,
    canManageWlc: (state) => (!state.user.ssoUser || state.organization.allowWlcForLinda) && state.user.adminPrivileges,
    canViewIntegrations: (state) => !state.organization.isLinda || state.organization.allowUsersForLinda || state.trueUserRoot,
    canManageApiKeys: (state) => !state.organization.isLinda,
    isRoot: (state) => state.trueUserRoot,
    // Staff gate for internal-only UI. OR on current_user covers staff browsing directly,
    // since true_user is unset outside impersonation; trueUserSystem survives impersonation.
    isStaffViewer: (state) => state.trueUserSystem || Boolean(state.user?.system)
  },

  actions: {
    setGlobalData(data) {
      this.wlc = data.wlcData
      this.user = data.user
      this.organization = data.organization
      this.trueUserRoot = data.trueUserRoot || false
      this.trueUserAppAdmin = data.trueUserAppAdmin || false
      this.trueUserContentTeam = data.trueUserContentTeam || false
      this.trueUserSystem = data.trueUserSystem || false
      this.currentPath = data.currentPath
      this.googleMapApiKey = data.googleMapApiKey
      this.maptilerKey = data.maptilerKey
      this.orgAlerts = data.orgAlerts || { base: {}, custom: []}
    }
  }
})
